import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import GroupReportsWrapper from "./GroupReportsWrapper.js";
import {
  generateOriginalValue,
  handleNumDisplay,
} from "../Reports/utils/ReportUtils";
import i18n from "../../modules/Auth/pages/i18n.js";
import { useTranslation } from "react-i18next";

function GroupCashCounterReport(props) {
  const { t } = useTranslation();

  useEffect(() => {
    i18n.changeLanguage(props.selectedLanguage);
  }, [props.selectedLanguage]);

  const columns = [
    { field: "hotelId", headerName: `${t("Hotel ID")}`, dataType: "varchar", checkboxSelection: true, headerCheckboxSelection: true },
    { field: "hotelName", headerName: `${t("Hotel Name")}`, dataType: "varchar" },
    { field: "bookingId", headerName: `${t("Booking ID")}`, dataType: "varchar" },
    { field: "reservationId", headerName: `${t("Reservation ID")}`, dataType: "varchar" },
    { field: "posOrderId", headerName: `${t("POS Order ID")}`, dataType: "varchar" },
    { field: "userEmail", headerName: `${t("User Email")}`, dataType: "varchar" },
    { field: "serviceDescription", headerName: `${t("Service Description")}`, dataType: "varchar" },
    { field: "serviceAmountDesc", headerName: `${t("Service Amount Desc")}`, dataType: "varchar" },
    { field: "creationDate", headerName: `${t("Creation Date")}`, dataType: "date" },
    { field: "logTimestamp", headerName: `${t("Log Timestamp")}`, dataType: "date" },
    { field: "serviceAmountType", headerName: `${t("Service Amount Type")}`, dataType: "varchar" },
    {
      field: "cashRefund",
      headerName: `${t("Cash Refund")}`,
      dataType: "float",
      aggFunc: "sum",
      valueGetter: (params) => generateOriginalValue(params, "cashRefund"),
      valueFormatter: (params) => handleNumDisplay(params, "float"),
      pinnedRowValueFormatter: (params) => handleNumDisplay(params, "float"),
    },
    { field: "roomIds", headerName: `${t("Room IDs")}`, dataType: "varchar" },
    {
      field: "amount",
      headerName: `${t("Amount")}`,
      dataType: "float",
      aggFunc: "sum",
      valueGetter: (params) => generateOriginalValue(params, "amount"),
      valueFormatter: (params) => handleNumDisplay(params, "float"),
      pinnedRowValueFormatter: (params) => handleNumDisplay(params, "float"),
    },
    {
      field: "netAmount",
      headerName: `${t("Net Amount")}`,
      dataType: "float",
      aggFunc: "sum",
      valueGetter: (params) => generateOriginalValue(params, "netAmount"),
      valueFormatter: (params) => handleNumDisplay(params, "float"),
      pinnedRowValueFormatter: (params) => handleNumDisplay(params, "float"),
    },
    { field: "customerName", headerName: `${t("Customer Name")}`, dataType: "varchar" },
    { field: "customerContact", headerName: `${t("Customer Contact")}`, dataType: "varchar" },
    { field: "customerEmail", headerName: `${t("Customer Email")}`, dataType: "varchar" },
    { field: "approved", headerName: `${t("Approved")}`, dataType: "varchar" },
  ];

  const [pinnedRow, setPinnedRow] = useState(null);
  function createPinnedData(params) {
    const result = {};
    for (let i = 0; i < columns.length; i++) {
      if (["integer", "float"].includes(columns[i].dataType)) {
        result[columns[i].field] = 0;
      }
    }

    function updateVals(i) {
      Object.keys(result).forEach((field) => {
        result[field] += i[`original_${field}`];
      });
    }

    params.api.getSelectedRows().length === 0
      ? params.api.forEachNodeAfterFilter((row) => updateVals(row.data))
      : params.api.getSelectedRows().forEach((row) => updateVals(row));

    result.bookingId = "Total";
    setPinnedRow([result]);
    params.api.setPinnedBottomRowData([result]);
  }

  return (
    <GroupReportsWrapper
      reportName={`${t("Group Cash Counter Report")}`}
      columns={columns}
      reportActualType={"groupCashCounterReport"}
      enableDateTypeFilters={false}
      createPinnedData={createPinnedData}
      pinnedRow={pinnedRow}
      selectedLanguage={props.selectedLanguage}
    />
  );
}

function mapStateToProps(state) {
  return { data: state.auth.hotels[0] };
}
export default connect(mapStateToProps)(GroupCashCounterReport);
